module.exports = __webpack_public_path__ + "img/icon_yesterday_account.73f9144c.png";